export default __webpack_public_path__ + "static/media/le_lion4.f9cc3dfe.jpg";